<template>
  <my-modal v-model:visible="visibleModel" :title="title" @save="handleSave">
    <div v-if="item">
      <my-input v-model="item.treatmentAt" required label="Эмчилгээний он сар" :mask="['####-##', '####-##-##']" placeholder="ЖЖЖЖ-СС" />
      <my-input v-model="item.treatmentDays" label="Эмчилгээний өдөр цагууд" :mask="maskDays" placeholder="ӨӨ цц:мм, ӨӨ цц:мм, ..." />
      <my-input v-model="item.note" required type="textarea" label="Тайлбар" />
    </div>
  </my-modal>
</template>
<script>
export default {
  props: {
    id: { type: Number, default: null },
    visible: { type: Boolean, default: false }
  },
  data () {
    return {
      reseting: false,
      loading: false,
      saving: false,
      temp: {
        treatmentAt: '',
        treatmentDays: '',
        note: null
      },
      item: null
    }
  },
  computed: {
    title: {
      get () {
        return this.id ? 'Бүртгэл засварлах' : 'Шинээр бүртгэх'
      }
    },
    visibleModel: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    maskDays () {
      const mask = []
      let str = '## ##:##'
      for (const i of Array(10).keys()) {
        mask.push(str)
        str += ', ## ##:##'
      }
      return mask
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.handleRefresh()
      }
    }
  },
  methods: {
    async handleRefresh () {
      try {
        this.loading = true
        if (this.id === null) {
          this.item = Object.assign({}, this.temp)
        } else {
          this.item = (await this.axios.get(`lookups/treatment/${this.id}`)).data
        }
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    async handleSave () {
      try {
        if (!this.item.treatmentAt) {
          this.customError('Эмчилгээний он сар оруулна уу.')
        }
        if (!this.item.treatmentAt.includes('-')) {
          this.customError('Эмчилгээний он сар буруу байна.')
        }
        const ta = this.item.treatmentAt.split('-')
        const year = Number(ta[0])
        const month = Number(ta[1])
        if (year < 2011 || year > 2100 || month <= 0 || month > 12) {
          this.customError('Эмчилгээний он сар буруу байна.')
        }
        if (this.item.treatmentDays) {
          this.item.treatmentDays.split(',').map(c => {
            const treatmentDay = c.trim()
            if (!treatmentDay.includes(' ') || !treatmentDay.includes(':')) {
              this.customError('Эмчилгээний өдөр цагууд буруу байна.')
            }
            const tad = treatmentDay.split(' ')
            const tam = tad[1].split(':')
            function wrongTimeStr (val) {
              return !val || val.trim() === '' || val.trim().length !== 2
            }
            if (wrongTimeStr(tad[0]) || wrongTimeStr(tam[0]) || wrongTimeStr(tam[1])) {
              this.customError('Эмчилгээний өдөр цагууд буруу байна.')
            }
            const day = Number(tad[0])
            const hour = Number(tam[0])
            const minute = Number(tam[1])
            if (day < 1 || day > 31 || hour < 0 || hour > 24 || minute < 0 || minute > 59) {
              this.customError('Эмчилгээний өдөр цагууд буруу байна.')
            }
          })
        }
        await this.showConfirm({ message: 'Бүртгэлийг хадгалахдаа итгэлтэй байна уу?' })
        if (this.saving) return
        this.saving = true
        const data = (await this.axios.post('lookups/treatment', this.item)).data
        this.$emit('saveSuccess', Object.assign({}, this.item, data))
        this.showToast('Амжилттай хадгаллаа.')
      } catch (err) {
        this.handleError(err)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
